export default __webpack_public_path__ + "/assets/imgs/homescreen-V2_ios-76x76.png";